import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { manageProposalModal, editProposal } from "ProposalAction";
import Navigation from "./navigation";
import ProposalForm from "./edit-proposal";
import ProposalFormBuilder from "./edit-formbuilder";
import AddReviewer from "./edit-reviewer";
import ReviewCriteria from "./edit-criteria";
import Publish from "../publish";
import LocaleStrings from "Languages";

class ManageProposal extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    //this.handleSelect = this.handleSelect.bind(this);
    this.state = { loading: false, selectedTab: 1 };
  }

  componentDidMount() {}

  closeModal() {
    this.props.editProposal({});
    this.props.manageProposalModal(false, "", "");
  }

  render() {
    var { showManageProposalModal, ProposalStep, updateProposal } = this.props;

    return (
      <div>
        <Modal
          className="modal-container proposalModal"
          enforceFocus={false}
          show={showManageProposalModal.showModal === true ? true : false}
          animation={true}
          dialogClassName="proposalModal"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.manage_proposal}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>

          <Modal.Body>
            <div style={{ width: "100%", marginBottom: 10 }}>
              <div className="row" style={{ margin: 0 }}>
                <Navigation />
              </div>
              {ProposalStep == "step_1" ? (
                <div className="row" style={{ margin: 0, marginLeft: "20px" }}>
                  <div className="col-md-12">
                    <ProposalForm history={this.props.history} />
                  </div>
                </div>
              ) : ProposalStep == "step_2" ? (
                <div className="row" style={{ margin: 0 }}>
                  <div className="col-md-12">
                    <ProposalFormBuilder />
                  </div>
                </div>
              ) : ProposalStep == "step_3" ? (
                <div className="row" style={{ margin: 0 }}>
                  <div className="col-md-12">
                    <AddReviewer />
                  </div>
                </div>
              ) : ProposalStep == "step_4" ? (
                <div className="row" style={{ margin: 0 }}>
                  <div className="col-md-12">
                    <ReviewCriteria />
                  </div>
                </div>
              ) : ProposalStep == "step_5" ? (
                <div className="row" style={{ margin: 0 }}>
                  <div className="col-md-12">
                    <Publish comesfrom="editAbstract" />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              bsStyle=""
              onClick={this.closeModal}
            >
              {LocaleStrings.button_close}
            </Button>
            {/* <Button className="btn btn-custom-blue ml-10" bsStyle="" loading={this.state.loading} disabled={ pristine || invalid || submitting } type="submit">{LocaleStrings.rank_proposal}</Button> */}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = {};
  if (state.updateProposal && state.updateProposal.proposalid) {
    initVals = state.updateProposal ? state.updateProposal : {};
  }

  return {
    session: state.session,
    showManageProposalModal: state.showManageProposalModal,
    ProposalStep: state.ProposalStep,
    updateProposal: state.updateProposal,
    initialValues: initVals,
    editMode: !_.isEmpty(state.updateProposal),
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  manageProposalModal,
  editProposal,
})(ManageProposal);
